"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var ProfileButton_1 = __importDefault(require("../BottomHeader/ProfileButton"));
var Logo_1 = __importDefault(require("../../Logo/Logo"));
var hamburger_svg_1 = __importDefault(require("../../../../images/hamburger.svg"));
var i18n_1 = __importDefault(require("../../../i18n"));
var Routes_1 = require("../../../constants/Routes");
var Localization_1 = require("../../../constants/Localization");
var useActionForbidden_1 = require("../../../hooks/useActionForbidden");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var T = 'NEW_HEADER';
// Inline icons on one 24px grid: unicode glyphs (⇄ ♡ ✉) differ in size and
// baseline per font, so they never line up inside the round buttons.
var iconProps = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};
var CompareIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("path", { d: "M4 8h14l-3-3M20 16H6l3 3" }))); };
var HeartIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("path", { d: "M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" }))); };
var MailIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("rect", { x: "3.5", y: "5.5", width: "17", height: "13", rx: "2" }),
    react_1.default.createElement("path", { d: "M4 7l8 6 8-6" }))); };
var NAV_ITEMS = [
    { key: 'NAV_SALE', deal: 'sell', query: '' },
    { key: 'NAV_RENT', deal: 'rent', query: 'rental_price_type=monthly_price' },
    { key: 'NAV_DAILY', deal: 'rent', query: 'rental_price_type=daily_price' },
    {
        key: 'NAV_NEW_BUILD',
        deal: 'sell',
        query: 'structure_type=new_building',
    },
    { key: 'NAV_HOUSES', deal: 'sell', query: 'property_type=house' },
    { key: 'NAV_COMMERCIAL', deal: 'sell', query: 'property_type=commercial' },
    { key: 'NAV_MORTGAGE' },
    { key: 'NAV_AGENTS' },
];
var NewHomeHeader = function (_a) {
    var user = _a.user, open = _a.open, currentLanguage = _a.currentLanguage, openMobileMenu = _a.openMobileMenu, openAccountList = _a.openAccountList, onDismiss = _a.onDismiss;
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    // Same guard as the current header: guests get the login form first.
    var openAnnouncement = useActionForbidden_1.useActionForbidden(function () {
        history.push(Routes_1.Routes.Announcement.path);
    });
    var openWishlist = useActionForbidden_1.useActionForbidden(function () {
        history.push("" + Routes_1.Routes.Account.path + Routes_1.Routes.Wishlist.path);
    });
    var searchLink = function (deal, query) {
        var page = Localization_1.SellPagePrefix[i18n_1.default.language][deal];
        return "/" + page + "?page=1" + (query ? "&" + query : '');
    };
    // Placeholder for features from the ticket that don't exist yet: muted text
    // with a "Soon" tooltip on hover, same as the icons above and the home form.
    var renderSoon = function (key, className) { return (react_1.default.createElement("span", { key: key, className: classnames_1.default(className, styles_module_scss_1.default.soon), "data-hint": t(T + ".SOON") }, t(T + "." + key))); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bar },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.left },
                    react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.hamburger, onClick: openMobileMenu },
                        react_1.default.createElement("img", { src: hamburger_svg_1.default, alt: "menu" })),
                    react_1.default.createElement(Logo_1.default, { currentLanguage: currentLanguage })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.right },
                    react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.icon, styles_module_scss_1.default.soon), "data-hint": t(T + ".COMPARE") + " \u00B7 " + t(T + ".SOON") },
                        react_1.default.createElement(CompareIcon, null)),
                    react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.icon, title: t(T + ".FAVORITES"), onClick: openWishlist },
                        react_1.default.createElement(HeartIcon, null)),
                    react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.icon, styles_module_scss_1.default.soon), "data-hint": t(T + ".MESSAGES") + " \u00B7 " + t(T + ".SOON") },
                        react_1.default.createElement(MailIcon, null)),
                    react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.post, onClick: openAnnouncement }, t(T + ".POST_FREE")),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.profile },
                        react_1.default.createElement(ProfileButton_1.default, { user: user, open: open, openAccountList: openAccountList, onDismiss: onDismiss }))))),
        react_1.default.createElement("nav", { className: styles_module_scss_1.default.nav },
            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.container, styles_module_scss_1.default.nav_inner) },
                NAV_ITEMS.map(function (_a) {
                    var key = _a.key, deal = _a.deal, query = _a.query;
                    if (!deal)
                        return renderSoon(key, styles_module_scss_1.default.nav_link);
                    return (react_1.default.createElement(react_router_dom_1.Link, { key: key, className: styles_module_scss_1.default.nav_link, to: searchLink(deal, query !== null && query !== void 0 ? query : '') }, t(T + "." + key)));
                }),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.nav_separator }),
                react_1.default.createElement(react_router_dom_1.Link, { className: styles_module_scss_1.default.pill, to: searchLink('sell', 'has_3D_tour=true') },
                    "\uD83C\uDFA5 ",
                    t(T + ".TOUR_3D"))))));
};
exports.default = NewHomeHeader;
